













































































































































































































































import { Component } from 'vue-property-decorator';
import { mixins } from 'vue-class-component';
import { Getter } from 'vuex-class';
import { Route, NavigationGuardNext } from 'vue-router';
import { ValidationObserver } from 'vee-validate';
import Datepicker from 'vuejs-datepicker';
import DatepickerZh from 'vuejs-datepicker/dist/locale/translations/zh';
import Draggable from 'vuedraggable';
import {
  format as formatDate,
  parse as parseDate,
} from 'date-fns';
import {
  postProgressDetail, postPhoto, getProgressDetail, putProgressDetail, deletePhoto,
} from '@/configs/api-path';
import CheckProjectMixin from '@/mixins/check-project';
import EditorActionMixin from '@/mixins/editor-action';
import ApiStatusMixin from '@/mixins/api-status';
import ApiErrorMixin from '@/mixins/api-error';
import InputFile from '@/components/InputFile.vue';
import ImageUploader from '@/components/ImageUploader3.vue';
import { ProjectMenu, AttachProject } from '@/models/project';
import { ProgressDetail } from '@/models/progress';
import { PhotoUpload } from '@/models/photo';
import { AlbumDetail } from '@/models/album';
import { generateId } from '@/utils/string';
import { getFileName } from '@/utils/file';
import sleep from '@/utils/sleep';

Component.registerHooks([
  'beforeRouteLeave',
]);

@Component({
  components: {
    Datepicker,
    InputFile,
    ImageUploader,
    Draggable,
  },
})
export default class PageProgressEdit extends mixins(
  CheckProjectMixin, EditorActionMixin, ApiStatusMixin, ApiErrorMixin,
) {
  $refs!: {
    formObs: InstanceType<typeof ValidationObserver>;
    albumFileInput: InstanceType<typeof InputFile>;
  }

  thumbnailCardClass = 'card-body align-self-center d-flex flex-column flex-lg-row justify-content-between min-width-zero align-items-lg-center';

  postPhoto = postPhoto;

  datepickerOptions = {
    lang: DatepickerZh,
    // disabledDates: {
    //   to: new Date(),
    // },
  }

  currentProject: AttachProject | null = null;

  progressForm: ProgressDetail = {
    projectId: null,
    title: null,
    note: null,
    publish_time: new Date(),
    is_send: false,
    message: null,
    album: [],
  }

  albumForm: {
    id: number | string;
    file: File;
  }[] = [];

  get methodTitle() {
    return this.isCreateAction ? '新增' : '編輯';
  }

  get submitText() {
    return this.isCreateAction ? '新增' : '儲存';
  }

  get projectId() {
    return this.$route.params.projectId;
  }

  get progressId() {
    return this.$route.params.progressId
      ? parseInt(this.$route.params.progressId, 10)
      : null;
  }

  get progressPublishDate() {
    return formatDate(this.progressForm.publish_time as Date || new Date(), 'yyyy-MM-dd');
  }

  set progressPublishDate(value: string) {
    this.progressForm.publish_time = parseDate(value, 'yyyy-MM-dd', new Date());
  }

  get isSendSms() {
    return this.progressForm.is_send;
  }

  get progressAlbum() {
    return this.progressForm.album;
  }

  get albumPhotos() {
    return this.progressAlbum.length;
  }

  get isFormChanged() {
    return this.$refs.formObs.flags.changed;
  }

  get breadcrumb() {
    return [
      {
        text: '進度管理',
        to: null,
      },
      {
        text: this.currentProject?.name,
        to: null,
      },
    ];
  }

  @Getter('app/getMenuProjectsAll') menuProjects!: ProjectMenu[];

  // eslint-disable-next-line class-methods-use-this
  getFileName(path: string) {
    return getFileName(path);
  }

  onAlbumInput(files: File[]) {
    files.forEach((file) => {
      this.albumForm.push({
        id: generateId(6),
        file,
      });
    });

    setTimeout(() => {
      this.$refs.albumFileInput.reset();
    });
  }

  onAlbumUploaded(album: {
    id: string;
    file: File;
    photo: PhotoUpload;
  }) {
    this.progressForm.album.unshift({
      id: album.photo.id,
      name: album.photo.photo_name,
      path: album.photo.path,
      updated_at: album.photo.updated_at,
      status: false,
    });

    this.onAlbumQueueDelete(album.id);
  }

  onAlbumQueueDelete(id: string) {
    const imageIndex = this.albumForm.findIndex(
      (item) => item.id === id,
    );
    this.albumForm.splice(imageIndex, 1);
  }

  cancelEdit() {
    const destination = this.currentProject
      ? {
        name: 'progress-list',
        params: {
          projectId: this.currentProject.id as string,
        },
      }
      : {
        name: 'dashboard',
      };

    this.$router.push(destination);
  }

  beforeRouteLeave(to: Route, from: Route, next: NavigationGuardNext) {
    if (this.isFormChanged) {
      // eslint-disable-next-line no-alert
      const confirm = window.confirm(`確定取消${this.methodTitle}？\n離開後變更的資料將不會被儲存。`);

      if (confirm === false) {
        return;
      }
      next();
      return;
    }
    next();
  }

  progressSubmit() {
    if (this.isCreateAction) {
      this.createProgressHandler();
    } else if (this.isEditAction) {
      this.editProgressHandler();
    }
  }

  async createProgressHandler() {
    if (!this.currentProject) {
      return;
    }

    this.setApiLoading();
    try {
      const date = {
        projectId: this.currentProject.id,
        title: this.progressForm.title,
        note: this.progressForm.note,
        publish_time: this.progressPublishDate,
        message: this.progressForm.message,
        album: this.progressForm.album.map((photo) => photo.id),
      };

      const { data: progressSubmit } = await this.$axios.post<{
        code: number;
        progress: {
          id: number;
        };
      }>(postProgressDetail, date);

      if (progressSubmit.code === 0) {
        this.$refs.formObs.reset();
        await sleep(0.1);
        this.$notify.show('success filled', '建案進度已成功新增！', `新增 ${this.currentProject.name} 進度`, { duration: 3000, permanent: false });
        this.$router.push(this.currentProject
          ? {
            name: 'progress-list',
            params: {
              projectId: this.currentProject?.id as string,
            },
          }
          : {
            name: 'dashboard',
          });
      } else {
        this.apiErrorCodeAlert(progressSubmit.code, `新增 ${this.currentProject.name} 進度`);
      }
    } catch (error) {
      console.error(error);
      this.apiHttpErrorAlert(error.response, `新增 ${this.currentProject.name} 進度`);
    }
    this.setApiPending();
  }

  async editProgressHandler() {
    if (!this.currentProject) {
      return;
    }
    if (!this.progressId) {
      return;
    }

    this.setApiLoading();
    try {
      const date = {
        title: this.progressForm.title,
        note: this.progressForm.note,
        publish_time: this.progressPublishDate,
        message: this.progressForm.is_send === true ? undefined : this.progressForm.message,
        album: this.progressForm.album.map((photo) => photo.id),
      };

      const { data: progressSubmit } = await this.$axios.put<{
        code: number;
        progress: {
          id: number;
        };
      }>(putProgressDetail(this.progressId), date);

      if (progressSubmit.code === 0) {
        this.$refs.formObs.reset();
        await sleep(0.1);
        this.$notify.show('success filled', '建案進度內容已更新！', `編輯 ${this.currentProject.name} 進度`, { duration: 3000, permanent: false });
        this.$router.push(this.currentProject
          ? {
            name: 'progress-list',
            params: {
              projectId: this.currentProject.id as string,
            },
          }
          : {
            name: 'dashboard',
          });
      } else {
        this.apiErrorCodeAlert(progressSubmit.code, `編輯 ${this.currentProject.name} 進度`);
      }
    } catch (error) {
      console.error(error);
      this.apiHttpErrorAlert(error.response, `編輯 ${this.currentProject.name} 進度`);
    }
    this.setApiPending();
  }

  async deleteAlbumItem(album: AlbumDetail) {
    if (!album.id) {
      return;
    }

    const confirm = window.confirm('確認刪除此照片？');

    if (confirm === false) {
      return;
    }

    try {
      const { data: deleteAlbumResponse } = await this.$axios.delete<{
        code: number;
        photo: {
          id: number;
        };
      }>(deletePhoto(album.id));

      if (deleteAlbumResponse.code === 0) {
        const itemIndex = this.progressAlbum.findIndex(
          (photo) => photo.id === album.id,
        );
        this.$notify.show(
          'success filled',
          `相簿照片 ${album.name} 已刪除！`,
          '編輯進度',
          { duration: 3000, permanent: false },
        );

        if (itemIndex !== -1) {
          this.progressAlbum.splice(itemIndex, 1);
        }
      } else {
        this.apiErrorCodeAlert(deleteAlbumResponse.code, '編輯進度');
      }
    } catch (error) {
      console.error(error);
    }
  }

  async fetchProgress() {
    if (!this.projectId) {
      return;
    }

    if (!this.progressId) {
      return;
    }

    this.setApiLoading();
    try {
      const { data: progressResponse } = await this.$axios.get<{
        code: number;
        progress: ProgressDetail;
      }>(getProgressDetail(this.progressId));

      if (progressResponse.code === 0) {
        this.progressForm = progressResponse.progress;

        this.progressPublishDate = progressResponse.progress.publish_time as string;

        setTimeout(() => {
          this.$refs.formObs.reset();
        }, 0);
      } else {
        this.apiErrorCodeAlert(progressResponse.code, '編輯建案進度');
        this.$router.replace(this.projectId
          ? {
            name: 'progress-list',
            params: {
              projectId: this.currentProject?.id as string,
            },
          }
          : {
            name: 'dashboard',
          });
      }
    } catch (error) {
      console.error(error);
      this.apiHttpErrorAlert(error.response, '編輯建案進度');
    }
    this.setApiPending();
  }

  async checkProjectAndFetch() {
    try {
      this.setApiLoading();
      const projectExist = await this.checkProjectExistII(this.projectId);
      this.setApiPending();

      if (projectExist.code === 0) {
        this.currentProject = {
          id: projectExist.project.id,
          name: projectExist.project.name,
        };

        if (this.editorAction && this.$route.params.progressId) {
          this.fetchProgress();
        }
      } else {
        this.$notify.show('error filled', projectExist.message, '進度管理');
      }
    } catch (error) {
      this.$notify.show('error filled', error.message, '進度管理');
      console.error(error.message);
    }
  }

  beforeMount() {
    this.checkProjectAndFetch();
  }
}
